import { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown, Popover, Row, Col, Tab, Nav } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import BulkTransfer from '../../../modal/Lead_Management/Manage_Lead/BulkTransfer';
import Add from '../../../modal/Lead_Management/Manage_Lead/AddLead';
import Edit from '../../../modal/Lead_Management/Manage_Lead/EditLead';
import View from '../../../modal/Lead_Management/Manage_Lead/View';
import Appointment from '../../../modal/Lead_Management/Manage_Lead/Appointment';
import Import from '../../../modal/Lead_Management/Manage_Lead/LeadImport';
import Followup from '../../../modal/Lead_Management/Manage_Lead/Followup';
import Followup_Report from '../../../modal/Lead_Management/Manage_Lead/Followup_Report';
import NewFollowup_Report from '../../../modal/Lead_Management/Manage_Lead/New_Followup_Report';
import AddLocation from '../../../modal/Lead_Management/Manage_Lead/AddLocation';
import ConvertLeadType from '../../../modal/Lead_Management/Manage_Lead/ConvertLeadType';
import CallLogs from '../../../modal/Lead_Management/Manage_Lead/Call_Logs';
import TransferLogs from '../../../modal/Lead_Management/Manage_Lead/TransferLogs';
import MobileValid from '../../../modal/Lead_Management/Manage_Lead/MobileValid';
import LoadingComponent from '../../../layouts/nav/loading';


import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import new_gif from '../../../../images/new_subs.gif';
import axios from 'axios';

import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};
const baseURL = process.env.REACT_APP_API_BASE_URL;

const Lead = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    // ------------------------------- role permission -------------------------------------------

    // default no permission structure
    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,

        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,


        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,
        lead_bulk_transfer: 0,
        lead_convert_type: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    // --------------------------------------------------- End permission ---------------------------------------------------------------------

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.toastMessage) {
            const type = location.state.toastType === 'success' ? toast.success : toast.error;
            type(location.state.toastMessage);
            // ✅ Clear location state so it doesn't show again on refresh
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [statusMap, setStatusMap] = useState({});
    const [convertedCount, setConvertedCount] = useState(0);
    // const [enquryCount, setEnquryCount] = useState(0);
    const [thismonthcount, setthismonthcount] = useState(0);
    const [loading, setLoading] = useState(true);

    const [total_lead, setTotalLead] = useState(0);
    const [total_spam, setTotalSpam] = useState(0);
    const [total_dead, setTotalDead] = useState(0);
    // const [total_call, settotalCall] = useState(0);
    const [total_followup, setTotalfollowup] = useState(0);
    const [pending_followup, setpendingfollowup] = useState(0);
    // const [reschedule_count, setrecount] = useState(0); 
    const [un_followup, setunfoll] = useState(0);

    const fetchcount = () => {
        const params = {
            branch_id: branch_id
        };
        axios.get(`${baseURL}/lead/counts`, { params: params })
            .then(response => {
                setTotalLead(response.data.lead);
                setTotalSpam(response.data.spam);
                setTotalDead(response.data.dead);
                setTotalfollowup(response.data.today_followup_count);
                // settotalCall(response.data.internal_call);
                setpendingfollowup(response.data.pending_count);
                // setrecount(response.data.reschedule_count);
                setunfoll(response.data.un_folowup);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }

    useEffect(() => {
        fetchcount();
    }, []);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const [bulktransfer, setBulkTransfer] = useState('d-none');
    const [selectedRows, setSelectedRows] = useState(new Set()); // store selected lead IDs
    const [allChecked, setAllChecked] = useState(false);

    const [overall_total_lead, setOverallTotalLead] = useState(0);
    const [total_customer, setTotalCustomer] = useState(0);
    const [this_month_lead, setMonthLead] = useState(0);
    const [this_month_customer, setmonthcustomer] = useState(0);
    const [total_today_followup, setTotaltodayfollowup] = useState(0);
    const [totalpending_followup, settotalpendingfollowup] = useState(0);
    const [total_unfollowup, settotalunfollowup] = useState(0);


    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id,
            user_id: user_id
        };
        axios.get(`${baseURL}/managelead`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setConvertedCount(response.data.converted_count.toString().padStart(2, '0'));
                // setEnquryCount(response.data.enquery_count.toString().padStart(2, '0'));
                setthismonthcount(response.data.this_month_enquery.toString().padStart(2, '0'));
                setBulkTransfer('d-none');
                setSelectedRows(new Set());
                setOverallTotalLead(response.data.total_lead.toString().padStart(2, '0'));
                setTotalCustomer(response.data.converted_count.toString().padStart(2, '0'));
                setMonthLead(response.data.thismonth_lead.toString().padStart(2, '0'));
                setmonthcustomer(response.data.thismonth_customer.toString().padStart(2, '0'));
                setTotaltodayfollowup(response.data.today_followup_count.toString().padStart(2, '0'));
                settotalpendingfollowup(response.data.pending_followup_count.toString().padStart(2, '0'));
                settotalunfollowup(response.data.un_folowup_count.toString().padStart(2, '0'));
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    // useEffect(() => {
    //     // fetchData();
    //     handlefilter();
    // }, [page, searchTerm, perPage]);

    useEffect(() => {
        axios.get(`${baseURL}/getleadstatus`)
            .then(response => {
                const mapping = {};
                response.data.data.forEach(status => {
                    mapping[status.sno] = {
                        label: status.leadstatus_name,
                        bg: status.background_color,
                        color: status.text_color
                    };
                });
                setStatusMap(mapping);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }, []);

    const tableRef = useRef(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    // add page
    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };

    const [reasons, setReasons] = useState([]);
    const [deadreasons, setdeadReasons] = useState([]);
    const [callreason, setCallReason] = useState([]);

    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/spamreason/getactive`);
                const formattedsource = response.data.data.map(item => item.reason_name);
                setReasons(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/deadreason/getactive`);
                const formattedsource = response.data.data.map(item => item.reason_name);
                setdeadReasons(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // Internal Call
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/internalcall/getactive`);
                const formattedsource = response.data.data.map(item => item.reason_name);
                setCallReason(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const handleModalTogglespam = (id, label, data) => {
        // Generate options dynamically
        const reasonOptions = reasons.map(reason =>
            `<option value="${reason}">${reason}</option>`
        ).join('');

        swal.fire({
            html: `
                <div class="alert alert-info px-2 py-2" role="alert">
                    Are You Sure Want to Change Status
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row mb-2 text-center">
                    <label class="text-black font-w300"><b>${data.lead_name} - ${data.mobile_no}</b></label>
                </div>
                <div class="text-center mt-4 mb-3">
                    <label class="fw-bold text-green fs-2">${label}</label>
                </div>
                <div class="form-group text-start mt-3">
                    <label for="reasonSelect" class="form-label">Select Reason<span class="required">*</span></label>
                    <select id="reasonSelect" class="form-select">
                        <option value="">Select a Reason</option>
                        ${reasonOptions}
                    </select>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reasonSelect').value;
                if (!reason) {
                    swal.showValidationMessage('Please select a reason');
                    return false;
                }
                return { reason };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.put(`${baseURL}/managelead/status/${data.sno}`, {
                    lead_status: id,
                    conversion_reason: result.value.reason,
                    user_id: user_id
                })
                    .then((result) => {
                        // window.location.reload();
                        fetchData();
                        fetchcount();
                        toast.success("Lead Updated Successfully!");
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("Lead Updation Failed");
                    });
            }
        });
    };

    const handleModalToggledead = (id, label, data) => {
        // Generate options dynamically
        const reasonOptions = deadreasons.map(reason =>
            `<option value="${reason}">${reason}</option>`
        ).join('');

        swal.fire({
            html: `
                <div class="alert alert-info px-2 py-2" role="alert">
                    Are You Sure Want to Change Status
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row mb-2 text-center">
                    <label class="text-black font-w300"><b>${data.lead_name} - ${data.mobile_no}</b></label>
                </div>
                <div class="text-center mt-4 mb-3">
                    <label class="fw-bold text-green fs-2">${label}</label>
                </div>
                <div class="form-group text-start mt-3">
                    <label for="reasonSelect" class="form-label">Select Reason<span class="required">*</span></label>
                    <select id="reasonSelect" class="form-select">
                        <option value="">Select a Reason</option>
                        ${reasonOptions}
                    </select>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reasonSelect').value;
                if (!reason) {
                    swal.showValidationMessage('Please select a reason');
                    return false;
                }
                return { reason };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.put(`${baseURL}/managelead/status/${data.sno}`, {
                    lead_status: id,
                    conversion_reason: result.value.reason,
                    user_id: user_id
                })
                    .then((result) => {
                        // window.location.reload();
                        fetchData();
                        fetchcount();
                        toast.success("Lead Updated Successfully!");
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("Lead Updation Failed");
                    });
            }
        });
    };

    // internal call
    const handleModalToggleCall = (data) => {
        // Generate options dynamically
        const reasonOptions = callreason.map(reason =>
            `<option value="${reason}">${reason}</option>`
        ).join('');

        swal.fire({
            html: `
                <div class="alert alert-info px-2 py-2" role="alert">
                    Are You Sure Want to Convert to Internal Calls ?
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row mb-2 text-center">
                    <label class="text-black font-w300"><b>${data.lead_name} - ${data.mobile_no}</b></label>
                </div>
                
                <div class="form-group text-start mt-3">
                    <label for="reasonSelect" class="form-label">Select Reason<span class="required">*</span></label>
                    <select id="reasonSelect" class="form-select">
                        <option value="">Select a Reason</option>
                        ${reasonOptions}
                    </select>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reasonSelect').value;
                if (!reason) {
                    swal.showValidationMessage('Please select a reason');
                    return false;
                }
                return { reason };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.post(`${baseURL}/managelead/internal_call/${data.sno}`, {
                    conversion_reason: result.value.reason,
                    user: user_id
                })
                    .then((result) => {
                        // window.location.reload();
                        fetchData();
                        fetchcount();
                        toast.success("Lead Converrted Successfully!");
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("Lead convertion Failed");
                    });
            }
        });
    };

    const [selectedId, setSelecctedID] = useState("");

    // edit page
    const handleModalToggle_Edit = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("Edit");
        setOpen(true);
    };

    // view page
    const handleModalToggle_view = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("View");
        setOpen(true);
    };

    // Lead status change
    const toggle_status_change = (id, lable, data) => {
        swal.fire({
            html: `
                   <div class="alert alert-info px-2 py-2" role="alert">
                       Are You Sure Want to Change Status
                       <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                   </div>
                    <div class="row mb-2 text-center">
                        <label class="text-black font-w300"><b>${data.lead_name} - ${data.mobile_no}</b></label>
                    </div>
                   <div class="text-center mt-4 mb-3">
                       <label class="fw-bold text-green fs-2">${lable}</label>
                   </div>
               `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.put(`${baseURL}/managelead/status/${data.sno}`, { lead_status: id })
                    .then((result) => {
                        // window.location.reload();
                        fetchData();
                        fetchcount();
                    });
            }
        });
    };

    // location popup
    const [selecteddata, setSelecctedData] = useState({});
    const handleModallocation = (data) => {
        setSelecctedData(data);
        setModalType("Location");
        setOpen(true);
    };

    // bulk transfer model open
    const handleModalToggle_BulkTransfer = () => {
        setModalType("BulkTransfer");
        setOpen(true);
    };

    // all select bulk transfer
    const handleAllChange = (e) => {
        const checked = e.target.checked;
        setAllChecked(checked);

        if (checked) {
            // Select all lead IDs
            const allIds = new Set(datas.filter(data => data.is_followup !== 1 && data.status !== 3).map(data => data.sno));
            setSelectedRows(allIds);
            setBulkTransfer(allIds.size >= 1 ? 'd-block' : 'd-none');
        } else {
            // Clear selection
            setSelectedRows(new Set());
            setBulkTransfer('d-none');
        }
        // setBulkTransfer(checked ? 'd-block' : 'd-none');
    };

    // Toggle individual row
    const handleRowChange = (e, sno) => {
        const checked = e.target.checked;
        const newSelected = new Set(selectedRows);

        if (checked) {
            newSelected.add(sno);
        } else {
            newSelected.delete(sno);
        }

        setSelectedRows(newSelected);

        // Update "allChecked" if all rows selected
        setAllChecked(newSelected.size === datas.length);
        setBulkTransfer(newSelected.size > 0 ? 'd-block' : 'd-none');
    };

    // lead convert
    const handleconvertlead = (selectedId, data) => {
        setSelecctedID(selectedId);
        setSelecctedData(data);
        setModalType("Convert");
        setOpen(true);
    };

    // lead call logs
    const handleModalToggle_CallLog = (data) => {
        setModalType("CallLog");
        setSelecctedData(data);
        setOpen(true);
    };

    // lead transfer
    const handleModalToggle_Transfer = (data) => {
        setModalType("TransferLog");
        setSelecctedData(data);
        setOpen(true);
    };

    // lead mobile verifi popup
    const handleModalToggle_MobileValid = (data) => {
        setModalType("Mobilevalid");
        setSelecctedData(data);
        setOpen(true);
    };

    // --------------------------------------------------- Import ---------------------------------//
    // import message success
    const successimport = () => {
        // swal.fire({
        //     title: 'Lead Imported Successfully!',
        //     icon: 'success',
        //     showCancelButton: false,
        //     confirmButtonText: 'OK',
        //     customClass: {
        //         title: 'fs-6',
        //         confirmButton: 'btn btn-sm btn-primary',
        //     },
        //     allowOutsideClick: false,
        //     allowEscapeKey: false,
        // }).then((result) => {
        //     window.location.reload();
        // });
        fetchData();
    };

    // import message failed
    const faildimport = () => {
        swal.fire({
            title: 'Lead Import Failed',
            text: `Steamed Food`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK',
            customClass: {
                title: 'fs-6',
                confirmButton: 'btn btn-sm btn-primary',
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            window.location.reload();
        });
    };

    // open import popup
    const handleModalToggle_Import = () => {
        setModalType("Import");
        setOpen(true);
    };

    // ----------------------------------------------- Followup -----------------------------------------//
    const [followup_lead_name, setfollowupname] = useState('');
    const [followup_mobile_no, setfollowupMobileno] = useState('');
    const [followup_email_id, setfollowupEmailid] = useState('');

    // lead appointment & followup
    const handleModalToggle_appointment = (selectedId, name, mobile, email) => {
        setSelecctedID(selectedId);
        setfollowupname(name);
        setfollowupMobileno(mobile);
        setfollowupEmailid(email);
        setModalType("Appointment");
        setOpen(true);
    };
    const handleModalToggle_followupReport = (selectedId, name, mobile, email) => {
        setSelecctedID(selectedId);
        setfollowupname(name);
        setfollowupMobileno(mobile);
        setfollowupEmailid(email);
        setModalType("Followup_Report");
        setOpen(true);
    };
    const handleModalToggle_newfollowupReport = (selectedId, name, mobile, email) => {
        setSelecctedID(selectedId);
        setfollowupname(name);
        setfollowupMobileno(mobile);
        setfollowupEmailid(email);
        setModalType("NewFollowup_Report");
        setOpen(true);
    };
    const handleModalToggle_followup = (selectedId, name, mobile, email) => {
        setSelecctedID(selectedId);
        setfollowupname(name);
        setfollowupMobileno(mobile);
        setfollowupEmailid(email);
        setModalType("Followup");
        setOpen(true);
    };

    // ------------------------------------------ End Followup -------------------------------------------------------------//

    const onClose = () => {
        setFilterOpen(false);
    };

    // --------------------------------------------- Filter ----------------------------------------------//
    const [filterOpen, setFilterOpen] = useState(false);

    //area
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, { params: { branch_id: branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.area_name,
                }));
                const allOption = { value: null, label: "All" };
                setAreaOption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [leadstatusOptions, setLeadstatusOptions] = useState([]);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/getleadstatus`);
                const formatted = response.data.data.filter(item => item.sno != 2 && item.sno != 4).map(item => ({
                    value: item.sno,
                    label: item.leadstatus_name,
                }));
                const allOption = { value: '', label: "All" };
                setLeadstatusOptions([allOption, ...formatted]);
            } catch (error) {
                console.error('Error fetching lead status:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/getleadsource`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.leadsource_name,
                }));
                const allOption = { value: '', label: "All" };
                setLeadSourceOptions([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching lead source:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const [lead_id, setLeadId] = useState(null);
    const [email_id, setFilterEmail] = useState('');
    const [mob_no, setFiltermob] = useState('');
    const [lead_status, setLeadstatus] = useState('');
    const [lead_source, setLeadsource] = useState('');
    const [lead_type, setLeadtype] = useState('');
    const [value_filter, setvaluefilter] = useState('');
    const handleGoClick = () => {
        const filter = {
            sno: lead_id || '',
            area: area || '',
            email_id: email_id || '',
            mobile_no: mob_no || '',
            lead_source: lead_source || '',
            lead_status: lead_status || '',
            lead_type: lead_type || '',
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData(filter);
        onClose();
    };

    // ---------------------------------------------- End filter --------------------------------

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // -------------------------------------------------- export -----------------------------------//

    const exportCSV = async () => {
        try {
            const filter = {
                sno: lead_id || '',
                area: area || '',
                email_id: email_id || '',
                mobile_no: mob_no || '',
                lead_source: lead_source || '',
                lead_status: lead_status || '',
                lead_type: lead_type || '',
                date_filter: date_fil_selt_value || '',
                filter: value_filter || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id
            };

            const response = await axios.get(`${baseURL}/managelead`, { params });
            const allData = response.data.data;

            if (allData && allData.length > 0) {
                const columnNames = [
                    'S.No', 'Lead ID', 'Lead Name', 'Mobile No', 'Email ID',
                    'Area', 'Latitude', 'Longitude', 'Address', 'Product',
                    'Sales Person', 'Lead Source', 'Lead Status'
                ];
                const formattedData = allData.map((item, index) => ({
                    'S.No': index + 1,
                    'Lead ID': item.lead_id,
                    'Lead Name': item.lead_name,
                    'Mobile No': item.mobile_no,
                    'Email ID': item.email_id,
                    'Area': item.area_name || '-',
                    'Latitude': item.latitude || '-',
                    'Longitude': item.longitude || '-',
                    'Address': item.address || '-',
                    'Product': item.product_names || '-',
                    'Sales Person': item.sales_person || '-',
                    'Lead Source': item.lead_sources_name || '-',
                    'Lead Status': item.lead_status_name || '-'
                }));
                const csv = Papa.unparse({
                    fields: columnNames,
                    data: formattedData
                });
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'lead.csv';
                link.click();
            } else {
                swal.fire({
                    title: 'No Data to Export!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            }
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const exportExcel = async () => {
        try {

            const filter = {
                sno: lead_id || '',
                area: area || '',
                email_id: email_id || '',
                mobile_no: mob_no || '',
                lead_source: lead_source || '',
                lead_status: lead_status || '',
                lead_type: lead_type || '',
                date_filter: date_fil_selt_value || '',
                filter: value_filter || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id
            };

            const response = await axios.get(`${baseURL}/managelead`, { params });
            const allData = response.data.data;

            if (allData.length > 0) {
                // Format the data to include the desired columns
                const formattedData = allData.map((item, index) => ({
                    'S.No': index + 1,
                    'Lead ID': item.lead_id,
                    'Lead Name': item.lead_name,
                    'Mobile No': item.mobile_no,
                    'Email ID': item.email_id,
                    'Area': item.area_name || '-',
                    'Latitude': item.latitude || '-',
                    'Longitude': item.longitude || '-',
                    'Address': item.address || '-',
                    'Product': item.product_names || '-',
                    'Sales Person': item.sales_person || '-',
                    'Lead Source': item.lead_sources_name || '-',
                    'Lead Status': item.lead_status_name || '-'
                }));

                // Create worksheet from formatted data
                const ws = XLSX.utils.json_to_sheet(formattedData);

                // Create a new workbook and append the worksheet
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

                // Write the workbook to an Excel file and trigger the download
                XLSX.writeFile(wb, 'lead.xlsx');
            } else {
                swal.fire({
                    title: 'No Data to Export!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            }
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const print = async () => {
        try {
            const filter = {
                sno: lead_id || '',
                area: area || '',
                email_id: email_id || '',
                mobile_no: mob_no || '',
                lead_source: lead_source || '',
                lead_status: lead_status || '',
                lead_type: lead_type || '',
                date_filter: date_fil_selt_value || '',
                filter: value_filter || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };
            console.log(params);
            const response = await axios.get(`${baseURL}/managelead`, { params });
            const allData = response.data.data;

            if (allData.length > 0) {
                // Define the column names for printing
                const columnNames = [
                    'S.No', 'Lead Name', 'Mobile No', 'Email ID',
                    'Area', 'Latitude', 'Longitude', 'Address', 'Product',
                    'Sales Person', 'Lead Source', 'Lead Status'
                ];

                // Format the data to include the desired columns
                const formattedData = allData.map((item, index) => ({
                    'S.No': index + 1,
                    // 'Lead ID': item.lead_id,
                    'Lead Name': item.lead_name,
                    'Mobile No': item.mobile_no,
                    'Email ID': item.email_id || '-',
                    'Area': item.area_name || '-',
                    'Latitude': item.latitude || '-',
                    'Longitude': item.longitude || '-',
                    'Address': item.address || '-',
                    'Product': item.product_names || '-',
                    'Sales Person': item.sales_person || '-',
                    'Lead Source': item.lead_sources_name || '-',
                    'Lead Status': item.lead_status_name || '-'
                }));

                // Create an HTML table for printing
                let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
                    <thead>
                        <tr style="background-color: #025d3a; color: #ffffffff">`;

                // Add column headers
                columnNames.forEach(col => {
                    printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
                });

                printContent += `</tr></thead><tbody>`;

                // Add the rows of data
                formattedData.forEach(row => {
                    printContent += `<tr>`;
                    columnNames.forEach(col => {
                        printContent += `<td style="padding: 8px; border: 1px solid #025d3a;">${row[col]}</td>`;
                    });
                    printContent += `</tr>`;
                });

                printContent += `</tbody></table>`;

                // Open the print dialog
                const printWindow = window.open('', '', 'height=800,width=1000');
                printWindow.document.write('<html><head><title>Lead Details</title>');
                printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
                printWindow.document.write('</head><body>');
                printWindow.document.write(printContent);
                printWindow.document.write('</body></html>');
                printWindow.document.close(); // Necessary for IE >= 10
                printWindow.print();
            } else {
                swal.fire({
                    title: 'No Data to Print!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            }
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // soft refresh
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    const checkdate = (date) => {
        const isToday = new Date(date).toDateString() === new Date().toDateString();
        return isToday;
    }

    const [key, setKey] = useState('lead');

    const rowStyle = (data) => {
        if (data.status === 3) {
            return { backgroundColor: '#C2FBB6', borderBottom: '1px solid #ddd' };
        }
        // else if (data.lead_status === 2) {
        //     return { backgroundColor: '#FFB3B3', borderBottom: '1px solid #ddd' };
        // } else if (data.lead_status === 4) {
        //     return { backgroundColor: '#f1f379ff', borderBottom: '1px solid #ddd' };
        // }
        else if (data.is_followup === 1) {
            return { backgroundColor: '#ADD8E6', borderBottom: '1px solid #ddd' };
        } else {
            return {};
        }
    };

    // const month = new Date().toLocaleString('en-US', { month: 'short' });
    const month = new Date().toLocaleString('en-US', { month: 'long' }); // e.g., "August"
    const capitalized = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();

    // --------- mini dashboard filter ----------------------
    const handlefilter = (value) => {
        setLoading(true);
        const filter = {
            sno: lead_id || '',
            area: area || '',
            email_id: email_id || '',
            mobile_no: mob_no || '',
            lead_source: lead_source || '',
            lead_status: lead_status || '',
            lead_type: lead_type || '',
            date_filter: date_fil_selt_value || '',
            filter: value_filter || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData(filter);
    };

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    useEffect(() => {
        // fetchData();
        handlefilter();
    }, [page, searchTerm, perPage, value_filter]);

    const [isMaintenance, setIsMaintenance] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "managelead"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Branch</strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Skeleton width={30} height={30} borderRadius={12}/>
                        <Skeleton width={100}  />
                        <Skeleton width={30} height={30} borderRadius={12}/>
                        <Skeleton width={100}  />
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}>Manage Lead</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Lead Management</li>
                        </ol>
                    </div>
                    {permissions.lead_list === 1 && (
                        <>
                            <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                                <div className="d-flex flex-wrap align-items-center">
                                    <div className="d-flex align-items-center px-1 py-1">
                                        <label className="py-3 px-3 text-danger rounded-2" style={{ border: '1px solid #78b636', backgroundColor: '#C2FBB6', borderRadius: '10px', width: '25px', height: '25px', marginRight: '0.25rem' }}></label>
                                        <label className='fw-semibold text-black fs-6'>Customer</label>
                                    </div>
                                    <div className="d-flex align-items-center px-1 py-1">
                                        <label className="py-3 px-3 text-danger rounded-2" style={{ border: '1px solid #7BAED9', backgroundColor: '#ADD8E6', borderRadius: '10px', width: '25px', height: '25px', marginRight: '0.25rem' }}></label>
                                        <label className='fw-semibold text-black fs-6'>Followup Scheduled</label>
                                    </div>
                                    {/* <div className="d-flex align-items-center px-1 py-1">
                                    <label className="py-3 px-3 text-danger rounded-2" style={{ border: '1px solid #c5c903ff', backgroundColor: '#f1f379ff', borderRadius: '10px', width: '25px', height: '25px', marginRight: '0.25rem'}}></label>
                                    <label className="fw-semibold text-black fs-6">Spam Lead</label>
                                </div>
                                <div className="d-flex align-items-center px-1 py-1">
                                    <label className="py-3 px-3 text-danger rounded-2" style={{ border: '1px solid #D95B5B', backgroundColor: '#FFB3B3', borderRadius: '10px', width: '25px', height: '25px', marginRight: '0.25rem'}}></label>
                                    <label className="fw-semibold text-black fs-6">Dead Lead</label>
                                </div> */}
                                </div>
                            </div>
                            {open && modalType === "Add" && (
                                <Add show={open} onClose={() => setOpen(false)} refresh={softRefresh} count={fetchcount} />
                            )}
                            {open && modalType === "Edit" && (
                                <Edit show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} />
                            )}
                            {open && modalType === "View" && (
                                <View show={open} onClose={() => setOpen(false)} selectedId={selectedId} />
                            )}
                            {open && modalType === "Appointment" && (
                                <Appointment show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} name={followup_lead_name} mobile={followup_mobile_no} email={followup_email_id} />
                            )}
                            {open && modalType === "Followup" && (
                                <Followup show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} count={fetchcount} name={followup_lead_name} mobile={followup_mobile_no} email={followup_email_id} />
                            )}
                            {open && modalType === "Followup_Report" && (
                                <Followup_Report show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} count={fetchcount} name={followup_lead_name} mobile={followup_mobile_no} email={followup_email_id} />
                            )}
                            {open && modalType === "NewFollowup_Report" && (
                                <NewFollowup_Report show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} count={fetchcount} name={followup_lead_name} mobile={followup_mobile_no} email={followup_email_id} />
                            )}

                            {open && modalType === "Import" && (
                                <Import show={open} onClose={() => setOpen(false)} refresh={fetchData} count={fetchcount} />
                            )}
                            {open && modalType === "Location" && (
                                <AddLocation show={open} onClose={() => setOpen(false)} data={selecteddata} refresh={fetchData} />
                            )}
                            {open && modalType === "BulkTransfer" && (
                                <BulkTransfer show={open} onClose={() => setOpen(false)} selectedRows={selectedRows}
                                    onTransferComplete={() => {
                                        setOpen(false);
                                        setSelectedRows(new Set());
                                        setAllChecked(false);
                                        setBulkTransfer('d-none');
                                        softRefresh();
                                        fetchcount();
                                    }}
                                />
                            )}
                            {open && modalType === "Convert" && (
                                <ConvertLeadType show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} count={fetchcount} data={selecteddata} />
                            )}
                            {open && modalType === "CallLog" && (
                                <CallLogs show={open} onClose={() => setOpen(false)} data={selecteddata} />
                            )}
                            {open && modalType === "TransferLog" && (
                                <TransferLogs show={open} onClose={() => setOpen(false)} data={selecteddata} />
                            )}
                            {open && modalType === "Mobilevalid" && (
                                <MobileValid show={open} onClose={() => setOpen(false)} datas={selecteddata} />
                            )}
                        </>
                    )}
                </div>
            )}

            {permissions.lead_list === 1 && (
                <>
                    {loading ? (
                        <Col xl={12} className='mb-3'>
                            <div className="custom-tab-1">
                                <Nav as="ul" className="nav-tabs">
                                    {[1, 2, 3, 4].map((_, index) => (
                                        <Nav.Item as="li" key={index}>
                                            <Nav.Link disabled className="d-flex align-items-center">
                                                {/* Icon */}
                                                <Skeleton circle width={20} height={20} />

                                                {/* Label */}
                                                <div className="ms-2">
                                                    <Skeleton width={80} height={14} />
                                                </div>

                                                {/* Badge */}
                                                <div className="ms-2">
                                                    <Skeleton width={30} height={18} borderRadius={12} />
                                                </div>
                                            </Nav.Link>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                            </div>
                        </Col>
                    ) : (
                        <Col xl={12} className='mb-3'>
                            <div className="custom-tab-1">
                                <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                                    <Nav as="ul" className="nav-tabs">
                                        <Nav.Item as="li" >
                                            <Nav.Link eventKey="lead">
                                                <i className="fa-solid fa-users"></i>
                                                <label className="ms-2 fs-6">
                                                    Lead
                                                </label>
                                                <Badge bg=" badge-circle" className='badge-outline-success ms-2 fw-bold fs-8'>
                                                    {total_lead}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" >
                                            <Nav.Link as={Link} to="/manage-spam-lead">
                                                <i className="fa-solid fa-users-slash"></i>
                                                <label className="ms-2 fs-6">
                                                    Spam Lead
                                                </label>
                                                <Badge bg=" badge-circle" className='badge-outline-warning ms-2 fw-bold fs-8'>
                                                    {total_spam}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" >
                                            <Nav.Link as={Link} to="/manage-dead-lead">
                                                <i className="fa-solid fa-users-rays"></i>
                                                <label className="ms-2 fs-6">
                                                    Dead Lead
                                                </label>
                                                <Badge bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                                    {total_dead}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" >
                                            <Nav.Link as={Link} to="/manage-today-followup">
                                                <i className="fa-solid fa-calendar-day"></i>
                                                <label className="ms-2 fs-6">
                                                    Today Followup
                                                </label>
                                                <Badge bg=" badge-circle" className='badge-outline-info ms-2 fw-bold fs-8'>
                                                    {total_followup}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Tab.Container>
                            </div>
                        </Col>
                    )}
                </>
            )}

            {permissions.lead_list === 1 && (
                <>
                    {loading ? (
                        <>
                            <div className="row mb-3">
                                <div className="d-flex justify-content-between w-100">

                                    {/* Left Summary Boxes */}
                                    <div className="d-flex flex-wrap">
                                        {[1, 2, 3, 4, 5, 6].map((_, index) => (
                                            <div className="me-2 mb-2" key={index}>
                                                <div
                                                    className="border rounded px-3 py-1 text-center"
                                                    style={{ width: 130, height: 90 }}
                                                >
                                                    {/* Title */}
                                                    <Skeleton width={80} height={14} />
                                                    <Skeleton width={60} height={14} style={{ marginTop: 4 }} />
                                                    {/* Number */}
                                                    <div className="mt-2">
                                                        <Skeleton width={40} height={24} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            </div>

                            {/* Right Buttons */}
                            <div className="d-flex align-items-end justify-content-end">
                                <div className="d-flex align-items-center gap-3 flex-wrap mb-2">
                                    {[1, 2, 3, 4, 5].map((_, index) => (
                                        <Skeleton
                                            key={index}
                                            width={110}
                                            height={34}
                                            borderRadius={6}
                                        />
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="row mb-3">
                                <div className="d-flex justify-content-between w-100">

                                    {/* Left: */}
                                    <div className="d-flex">
                                        <div className="me-2">
                                            <div className="border rounded px-3 py-1 border-info bg-info-light text-center cursor-pointer" onClick={() => setvaluefilter('total_lead')}>
                                                <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                                    Total
                                                    <span className='d-block cursor-pointer'> Leads </span>
                                                </label>
                                                <div className="d-block text-center">
                                                    <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                                        <span>{overall_total_lead}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="me-2">
                                            <div className="border rounded px-3 py-1 border-success bg-success-light text-center cursor-pointer" onClick={() => setvaluefilter('converted')}>
                                                <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                                    Converted
                                                    <span className='d-block cursor-pointer'>Customers</span>
                                                </label>
                                                <div className="d-block text-center">
                                                    <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                                        <span>{total_customer}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="me-2">
                                            <div className="border rounded px-3 py-1 border-info bg-info-light text-center cursor-pointer" onClick={() => setvaluefilter('month_lead')}>
                                                <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                                    {capitalized}
                                                    <span className='d-block cursor-pointer'>Leads</span>
                                                </label>
                                                <div className="d-block text-center">
                                                    <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                                        <span>{this_month_lead}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="me-2">
                                            <div className="border rounded px-3 py-1 border-success bg-success-light text-center cursor-pointer" onClick={() => setvaluefilter('month_customer')}>
                                                <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                                    {capitalized}
                                                    <span className='d-block cursor-pointer'>Customers</span>
                                                </label>
                                                <div className="d-block text-center">
                                                    <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                                        <span>{this_month_customer}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {total_today_followup !== "00" && (
                                            <div className='me-2'>
                                                <Link to={"#"} onClick={() => setvaluefilter('today_followup')}>
                                                    <div className='border rounded px-3 py-1 border-warning bg-warning-light text-center cursor-pointer'>
                                                        <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                                            Today
                                                            <span className='d-block'>Followup</span>
                                                        </label>
                                                        <div className='d-block text-center'>
                                                            <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                                                <span className="text-danger">{total_today_followup}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        )}

                                        {totalpending_followup != "00" && (
                                            <div className='me-2'>
                                                <Link to={"#"} onClick={() => setvaluefilter('pending_followup')}>
                                                    <div className='border rounded px-3 py-1 border-danger bg-danger-light text-center cursor-pointer '>
                                                        <label className='text-black fs-6 text-nowrap'>
                                                            Pending
                                                            <span className='d-block  cursor-pointer'>Followup</span>
                                                        </label>
                                                        <div className='d-block text-center  cursor-pointer'>
                                                            <label className="text-danger fs-3 m-0 fw-bold">
                                                                <span className="text-danger  cursor-pointer">{totalpending_followup}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        )}

                                        {total_unfollowup !== "00" && (
                                            <div className='me-2'>
                                                <Link to={"#"} onClick={() => setvaluefilter('un_followup')}>
                                                    <div className='border rounded px-3 py-1 border border-dark text-center  cursor-pointer' style={{ background: '#DCDBDB' }}>
                                                        <label className='text-black fs-6 text-nowrap  cursor-pointer'>
                                                            Unfollowed
                                                            <span className='d-block  cursor-pointer'>Followup</span>
                                                        </label>
                                                        <div className='d-block text-center'>
                                                            <label className="text-danger fs-3 m-0 fw-bold  cursor-pointer">
                                                                <span className="text-danger  cursor-pointer">{total_unfollowup}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>

                            {/* right buttons */}
                            <div className="d-flex align-items-end justify-content-end">
                                <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                                    <Link to={"#"} className={`btn btn-primary float-end btn-sm ${bulktransfer}`} onClick={handleModalToggle_BulkTransfer} >
                                        <span className='me-2'><i className="fa-solid fa-arrow-up-from-bracket fs-7"></i></span>
                                        <span className=''>Bulk Transfer</span>
                                    </Link>
                                    {permissions.lead_list === 1 && (
                                        <button className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                                            <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                                            <span className=''>Filter</span>
                                        </button>
                                    )}
                                    {permissions.lead_import === 1 && (
                                        <button className="btn btn-primary float-end btn-sm" onClick={handleModalToggle_Import}>
                                            <span className='me-2'><i className="fa-solid fa-upload fs-8"></i></span>
                                            <span className=''>Import</span>
                                        </button>
                                    )}
                                    {permissions.lead_export === 1 && (
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                as="button"
                                                variant="primary"
                                                className="btn btn-primary text-white btn-sm"
                                                id="tp-btn"
                                            >
                                                <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                                                <span className=''>Export</span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={exportCSV} className='px-2'>
                                                    <img
                                                        src={csv_ico}
                                                        alt="CSV"
                                                        className='w-30px h-30px'
                                                    />
                                                    <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={exportExcel} className='px-2'>
                                                    <img
                                                        src={excel_ico}
                                                        alt="Excel"
                                                        className='w-30px h-30px'
                                                    />
                                                    <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={print} className='px-2'>
                                                    <img
                                                        src={print_ico}
                                                        alt="Print"
                                                        className='w-30px h-30px'
                                                    />
                                                    <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                    {permissions.lead_add === 1 && (
                                        <button className="btn btn-primary float-end btn-sm" onClick={handleModalToggle}>
                                            <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                                            <span className=''>Add Lead</span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}

            {permissions.lead_list === 1 && (
                <>
                    {loading ? (
                        <div className="table-container">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                {/* Left: Show entries dropdown */}
                                <div>
                                    <label className="me-2"><Skeleton width={50} height={25} /></label>
                                    <Skeleton width={50} height={25} className="mb-1" />
                                </div>

                                {/* Right: Search input */}
                                <div>
                                    <Skeleton width={150} height={25} className="mb-1" />
                                </div>
                            </div>

                            <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {[...Array(perPage)].map((_, i) => (
                                        <tr key={i}>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                {/* Bottom left: Showing x to y of z entries */}
                                <div>
                                    <Skeleton width={180} height={15} />
                                </div>

                                {/* Bottom right: Pagination */}
                                <nav>
                                    <div className="d-flex gap-2">
                                        {[...Array(4)].map((_, i) => (
                                            <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                        ))}
                                    </div>
                                </nav>
                            </div>
                        </div>
                    ) : (
                        <div className="table-container">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                {/* Left: Show entries dropdown */}
                                <div>
                                    <label className="me-2">Show</label>
                                    <select
                                        className="form-select d-inline w-auto"
                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                        value={perPage}
                                        onChange={(e) => {
                                            setPerPage(Number(e.target.value));
                                            setPage(1); // Reset to first page
                                        }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>

                                {/* Right: Search input */}
                                <div>
                                    <input
                                        type="text"
                                        style={{ fontSize: '0.85rem', height: '40px' }}
                                        placeholder="Search..."
                                        className="form-control"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            setPage(1); // Reset page on new search
                                        }}
                                    />
                                </div>
                            </div>

                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                        {/* {permissions.lead_bulk_transfer === 1 && ( */}
                                        <th className='max-w-50px'>
                                            <div>All</div>
                                            <input className="form-check-input d-block" type="checkbox" checked={allChecked} onChange={handleAllChange} />
                                        </th>
                                        {/* )} */}
                                        <th className='min-w-100px' style={{ width: '200px' }}>Lead /<br></br>Mobile No</th>
                                        <th className='min-w-100px'>Area / Email ID /<br></br>Lead Life Time</th>
                                        <th className='min-w-100px'>Product /<br></br>Lead Source</th>
                                        <th className='min-w-80px'>Sales Person /<br></br>Last Followup Date</th>
                                        <th className='min-w-50px text-center'>Followup<br></br>(Count / Score)</th>
                                        <th className='min-w-50px' style={{ textAlign: 'center' }}>Status</th>
                                        <th className='min-w-50px' style={{ textAlign: 'center' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7 align-middle">
                                    {datas.length === 0 && hasFetched ? (
                                        <tr>
                                            {/* <td colSpan={permissions.lead_bulk_transfer === 1 ? "8" : "7"} className="text-center text-muted py-2"> */}
                                            <td colSpan="8" className="text-center text-muted py-2">
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {datas.map((data, index) => (
                                                <tr key={data.sno} style={rowStyle(data)}>
                                                    {/* {permissions.lead_bulk_transfer === 1 && ( */}
                                                    <td>
                                                        <input className="form-check-input row_chk_1" type="checkbox" checked={selectedRows.has(data.sno)} onChange={(e) => handleRowChange(e, data.sno)} disabled={data.is_followup === 1 || data.status === 3} />
                                                    </td>
                                                    {/* )} */}
                                                    <td>
                                                        <OverlayTrigger trigger={['hover', 'click']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.lead_name}</span></Tooltip>} >
                                                            <div className='text-truncate mw-200px' style={{ color: 'black', fontWeight: 'semi-bold', fontSize: '1.1rem', maxWidth: '75%' }}>
                                                                {capitalizeFirstLetter(data.lead_name)}
                                                            </div>
                                                        </OverlayTrigger>
                                                        <div className='d-flex flex-wrap'>
                                                            <div className='text-dark font-w600 fs-8 align-content-center'>{data.mobile_no}</div>
                                                            {data.is_valid_mobile === 1 ? (
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Mobile No Verified</span> </Tooltip>}>
                                                                    <Button variant="primary tp-btn-light px-2 py-1" onClick={() => handleModalToggle_MobileValid(data)}>
                                                                        <i className="fa-solid fa-circle-check fs-5"></i>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Not Verified</span> </Tooltip>}>
                                                                    <Button variant="primary tp-btn-light px-2 py-1" onClick={() => handleModalToggle_MobileValid(data)}>
                                                                        <i className="fa-solid fa-circle-xmark fs-5 text-danger"></i>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            )}
                                                        </div>
                                                        {checkdate(data.created_at) && (
                                                            <img src={new_gif} alt="New Lead" className='w-60px h-20px' />
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.area_name ? data.area_name : '-'}</div>
                                                        <div className='d-block'>
                                                            <div className='text-dark font-w600 fs-8 text-wrap mw-75'>{data.email_id ? data.email_id : '-'}</div>
                                                        </div>
                                                        <div className='d-block'>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Lead Life Time</span> </Tooltip>}>
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Transfer(data)}>
                                                                    <Badge bg="badge-pill" className='badge-outline-primary'>
                                                                        {data.day_count} day
                                                                    </Badge>
                                                                </Button>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {data.product_names ? (() => {
                                                            const products = data.product_names.split(',').map(p => p.trim());
                                                            const visibleCount = 1;
                                                            const visibleProducts = products.slice(0, visibleCount);
                                                            const hiddenCount = products.length - visibleCount;

                                                            const popover = (
                                                                <Popover id="popover-products" className="toltip-popover" style={{ maxWidth: '200px' }}>
                                                                    <Popover.Body>
                                                                        {products.map((product, idx) => (
                                                                            <div key={idx} className="fs-8 text-black fw-semibold">
                                                                                {product}
                                                                            </div>
                                                                        ))}
                                                                    </Popover.Body>
                                                                </Popover>
                                                            );

                                                            return (
                                                                <>
                                                                    <span className="text-black font-w400 fs-7">
                                                                        {visibleProducts.join(', ')}
                                                                        {hiddenCount > 0 && ', '}
                                                                    </span>

                                                                    {hiddenCount > 0 && (
                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'click']}
                                                                            placement="bottom"
                                                                            overlay={popover}
                                                                            rootClose
                                                                        >
                                                                            <span
                                                                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                                className="fs-7 text-primary"
                                                                            >
                                                                                + {hiddenCount} more
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                </>
                                                            );
                                                        })() : (
                                                            <div className='text-truncate mw-300px text-black font-w400 fs-7'>-</div>
                                                        )}

                                                        <div className='d-block'>
                                                            <div className='text-info font-w600 fs-8 text-wrap mw-75'>{data.lead_sources_name}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>
                                                            {data.sales_person ? (
                                                                <>
                                                                    {data.sales_person}
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                                        overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Call Logs</span> </Tooltip>}>
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_CallLog(data)}>
                                                                            <span><i className="fa-solid fa-phone fs-5 mt-1"></i></span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                </>
                                                            ) : (
                                                                <span>-</span>
                                                            )}
                                                        </div>
                                                        <div className='d-block'>
                                                            <div className='text-danger fw-bold fs-8'>{data.last_followup_date ? formatDate(data.last_followup_date) : '-'}</div>
                                                        </div>
                                                    </td>
                                                    <td className='align-content-center'>
                                                        {data.followup_count > 0 ?
                                                            (<div className='text-center' style={{ verticalAlign: 'middle' }}>
                                                                <label className="text-nowrap d-inline-block me-3 position-relative">
                                                                    <div className="position-relative d-inline-block">
                                                                        {data.is_complete_followup === 0 ? (
                                                                            <Badge bg="none" className='py-1 px-2 fs-7 shadow-lg text-black  me-1' style={{ border: '1px solid #5757f7' }}>{String(data.followup_count).padStart(2, '0')}</Badge>
                                                                        ) : (
                                                                            <Badge bg="none" className='py-1 px-2 fs-7 shadow-lg  me-1 bg-primary text-white border-border-primary' >{String(data.followup_count).padStart(2, '0')}</Badge>
                                                                        )}

                                                                        {data.followup_score_bg && data.followup_score !== null && (
                                                                            <span className="position-absolute top-0 start-100 translate-middle">
                                                                                <Badge bg="none" className='py-1 px-1 fs-8 shadow-lg text-black rounded-pill  me-1 w-25px h-25px'
                                                                                    style={{
                                                                                        border: '1px solid ' + data.followup_score_border,
                                                                                        background: data.followup_score_bg
                                                                                    }}
                                                                                >
                                                                                    {data.followup_score ? data.followup_score : 0}
                                                                                </Badge>
                                                                            </span>
                                                                        )}

                                                                    </div>
                                                                </label>
                                                            </div>) :
                                                            (<div className='text-center'>
                                                                <div bg="none" className='fs-7 font-w600' style={{ color: '#ff0000' }}>No<br></br>Followup's</div>
                                                            </div>)
                                                        }
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} className='align-content-center'>
                                                        {data.status !== 3 && data.followup_count >= 2 && data.is_followup !== 1 ? (
                                                            <>
                                                                {![2, 4, 5, 6].includes(data.lead_status) ? (
                                                                    <Dropdown drop="">
                                                                        <Dropdown.Toggle as="a" className={`i-false ${permissions.lead_edit === 1 ? 'cursor-pointer' : ''} `}>
                                                                            <Badge bg="none" className='py-1 px-2 fs-8' style={{ background: data.leadstatus_relation.background_color, color: data.leadstatus_relation.text_color }}>{data.leadstatus_relation.leadstatus_name}</Badge>
                                                                        </Dropdown.Toggle>
                                                                        {permissions.lead_edit === 1 && (
                                                                            <Dropdown.Menu >
                                                                                {Object.entries(statusMap).map(([id, { label }]) => {
                                                                                    if (parseInt(id) !== data.lead_status && parseInt(id) !== 2 && parseInt(id) !== 4) {
                                                                                        if (parseInt(id) === 5) {
                                                                                            return (
                                                                                                <Dropdown.Item key={id} href="#" className="text-black" onClick={() => handleModalTogglespam(id, label, data)}>
                                                                                                    {label}
                                                                                                </Dropdown.Item>
                                                                                            )
                                                                                        } else if (parseInt(id) === 6) {
                                                                                            return (
                                                                                                <Dropdown.Item key={id} href="#" className="text-black" onClick={() => handleModalToggledead(id, label, data)}>
                                                                                                    {label}
                                                                                                </Dropdown.Item>
                                                                                            )
                                                                                        } else if (parseInt(id) !== 7) {
                                                                                            return (
                                                                                                <Dropdown.Item key={id} href="#" className="text-black" onClick={() => toggle_status_change(id, label, data)}>
                                                                                                    {label}
                                                                                                </Dropdown.Item>
                                                                                            );
                                                                                        }
                                                                                    }
                                                                                    return null;
                                                                                })}
                                                                            </Dropdown.Menu>
                                                                        )}
                                                                    </Dropdown>
                                                                ) : (
                                                                    <Badge bg="none" className='py-1 px-2 fs-8' style={{ background: data.leadstatus_relation.background_color, color: data.leadstatus_relation.text_color }}>{data.leadstatus_relation.leadstatus_name}</Badge>
                                                                )}
                                                            </>
                                                        ) : (
                                                            // <Badge bg="none" className='py-1 px-2 fs-8 bg-success text-black' >Customer</Badge>  
                                                            <Badge bg="none" className='py-1 px-2 fs-8' style={{ background: data.leadstatus_relation.background_color, color: data.leadstatus_relation.text_color }}>{data.leadstatus_relation.leadstatus_name}</Badge>
                                                        )}
                                                    </td>
                                                    <td className='align-content-center'>
                                                        {data.status !== 3 ? (
                                                            <div className="d-flex justify-content-end">

                                                                {data.lead_status === 1 && (
                                                                    <>
                                                                        {permissions.lead_followup === 1 && (
                                                                            <>
                                                                                {data.is_followup === 1 ? (
                                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Follow Up</span> </Tooltip>}>
                                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_followupReport(data.sno, data.lead_name, data.mobile_no, data.email_id)}>
                                                                                            <span>
                                                                                                {/* <i className="fa-solid fa-person-military-to-person fs-4 mt-1"></i> */}
                                                                                                <i className="fa-solid fa-calendar-check fs-4 mt-1"></i>
                                                                                            </span>
                                                                                        </Button>
                                                                                    </OverlayTrigger>
                                                                                ) : (
                                                                                    <>
                                                                                        {permissions.lead_followup === 1 && (
                                                                                            <>
                                                                                                {data.followup_count > 0 ? (
                                                                                                    <OverlayTrigger
                                                                                                        trigger={['hover', 'focus']}
                                                                                                        placement="bottom"
                                                                                                        overlay={
                                                                                                            <Tooltip className="toltip-popover">
                                                                                                                <span className="fs-8 text-white fw-semibold">Follow Up</span>
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <Button
                                                                                                            variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                                            onClick={() =>
                                                                                                                handleModalToggle_newfollowupReport(
                                                                                                                    data.sno,
                                                                                                                    data.lead_name,
                                                                                                                    data.mobile_no,
                                                                                                                    data.email_id
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <span>
                                                                                                                {/* <i className="fa-solid fa-person-military-to-person fs-4 mt-1"></i> */}
                                                                                                                <i className="fa-solid fa-calendar-check fs-4 mt-1"></i>
                                                                                                            </span>
                                                                                                        </Button>
                                                                                                    </OverlayTrigger>
                                                                                                ) : (
                                                                                                    <OverlayTrigger
                                                                                                        trigger={['hover', 'focus']}
                                                                                                        placement="bottom"
                                                                                                        overlay={
                                                                                                            <Tooltip className="toltip-popover">
                                                                                                                <span className="fs-8 text-white fw-semibold">Follow Up</span>
                                                                                                            </Tooltip>
                                                                                                        }
                                                                                                    >
                                                                                                        <Button
                                                                                                            variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                                            onClick={() =>
                                                                                                                handleModalToggle_followup(
                                                                                                                    data.sno,
                                                                                                                    data.lead_name,
                                                                                                                    data.mobile_no,
                                                                                                                    data.email_id
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <span>
                                                                                                                {/* <i className="fa-solid fa-person-military-to-person fs-4 mt-1"></i> */}
                                                                                                                <i className="fa-solid fa-calendar-check fs-4 mt-1"></i>
                                                                                                            </span>
                                                                                                        </Button>
                                                                                                    </OverlayTrigger>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}

                                                                        {permissions.lead_edit === 1 && (
                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                                                overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Add Location</span> </Tooltip>}>
                                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModallocation(data)}>
                                                                                    <span><i className="fa-solid fa-map-location-dot fs-4 mt-1"></i></span>
                                                                                </Button>
                                                                            </OverlayTrigger>
                                                                        )}

                                                                        {permissions.lead_subscribe === 1 && data.is_followup !== 1 && (
                                                                            <OverlayTrigger
                                                                                trigger={['hover', 'focus']}
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="toltip-popover">
                                                                                        <span className="fs-8 text-white fw-semibold">Subscription</span>
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <Link to={`/lead-to-subscription?data=${data.sno}`} >
                                                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                                                        <span>
                                                                                            <i className="fa-solid fa-handshake fs-4 mt-1"></i>
                                                                                        </span>
                                                                                    </Button>
                                                                                </Link>
                                                                            </OverlayTrigger>
                                                                        )}

                                                                    </>
                                                                )}

                                                                {(permissions.lead_edit === 1 || permissions.lead_view === 1) && (
                                                                    <Dropdown drop=''>
                                                                        <Dropdown.Toggle as="a" className="i-false cursor-pointer">
                                                                            <Button variant="primary tp-btn-light px-3 py-2">
                                                                                <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                                            </Button>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            {permissions.lead_view === 1 && (
                                                                                <Dropdown.Item className='px-2 py-1' onClick={() => handleModalToggle_view(data.sno)}>
                                                                                    <div className='d-flex align-items-center'>
                                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                            <span><i className="fa-solid fa-eye fs-5 mt-1 text-danger"></i></span>
                                                                                        </div>
                                                                                        <div className="ms-1 fs-7">View Lead</div>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                            )}
                                                                            {permissions.lead_edit === 1 && data.lead_status === 1 && (
                                                                                <Dropdown.Item className='px-2 py-1' onClick={() => handleModalToggle_Edit(data.sno)}>
                                                                                    <div className='d-flex align-items-center'>
                                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                            <span><i className="fa-solid fa-pen-to-square fs-5 mt-1 text-danger"></i></span>
                                                                                        </div>
                                                                                        <div className="ms-1 fs-7">Edit Lead</div>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                            )}
                                                                            {data.lead_status === 1 && data.is_followup !== 1 && permissions.lead_convert_type === 1 && (
                                                                                <Dropdown.Item className='px-2 py-1' onClick={() => handleconvertlead(data.sno, data)}>
                                                                                    <div className='d-flex align-items-center'>
                                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                            <span><i className="fa-solid fa-person-walking-arrow-right fs-4 mt-1 text-danger"></i></span>
                                                                                        </div>
                                                                                        <div className="ms-1 fs-7">Service Type</div>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                            )}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                )}

                                                            </div>
                                                        ) : (
                                                            <div className="d-flex justify-content-end">
                                                                {(permissions.lead_view === 1) && (
                                                                    <Dropdown drop=''>
                                                                        <Dropdown.Toggle as="a" className="i-false cursor-pointer">
                                                                            <Button variant="primary tp-btn-light px-3 py-2">
                                                                                <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                                            </Button>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            {permissions.lead_view === 1 && (
                                                                                <Dropdown.Item className='px-2 py-1' onClick={() => handleModalToggle_view(data.sno)}>
                                                                                    <div className='d-flex align-items-center'>
                                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                            <span><i className="fa-solid fa-eye fs-5 mt-1 text-danger"></i></span>
                                                                                        </div>
                                                                                        <div className="ms-1 fs-7">View</div>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                            )}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                )}
                                                            </div>
                                                        )}

                                                        {permissions.lead_edit != 1 && permissions.lead_followup != 1 && permissions.lead_view != 1 && permissions.lead_subscribe != 1 && (
                                                            <div className="text-center">
                                                                No Actions
                                                            </div>
                                                        )}

                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                {/* Bottom left: Showing x to y of z entries */}
                                <div>
                                    {datas.length > 0 ? (
                                        <span className="text-muted">
                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                        </span>
                                    ) : (
                                        <span className="text-muted">
                                            Showing 0 to 0 of 0 entries
                                        </span>
                                    )}
                                </div>

                                {/* Bottom right: Pagination */}
                                {/* <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav> */}

                                <nav>
                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                        {/* Previous Button */}
                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                Previous
                                            </button>
                                        </li>

                                        {/* First Page */}
                                        <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                1
                                            </button>
                                        </li>

                                        {/* Left Ellipsis */}
                                        {page > 4 && (
                                            <li className="page-item disabled">
                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                            </li>
                                        )}

                                        {/* Pages Around Current */}
                                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                                            .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                            .map(p => (
                                                <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                        {p}
                                                    </button>
                                                </li>
                                            ))}

                                        {/* Right Ellipsis */}
                                        {page < totalPages - 3 && (
                                            <li className="page-item disabled">
                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                            </li>
                                        )}

                                        {/* Last Page */}
                                        {totalPages > 1 && (
                                            <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                    {totalPages}
                                                </button>
                                            </li>
                                        )}

                                        {/* Next Button */}
                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>

                            </div>
                        </div>
                    )}
                </>
            )}

            {permissions.lead_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Lead Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Lead</label>
                                <Select
                                    options={leadoption}
                                    placeholder="Select Lead"
                                    value={leadoption.find(option => option.value === lead_id) || null}
                                    onChange={(selectedOption) => setLeadId(selectedOption.value)}
                                />
                            </div> */}
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Email ID</label>
                                <input type="text" className="form-control" placeholder="Enter Email ID" 
                                    value={email_id}
                                    onChange={(e) => 
                                        setFilterEmail(e.target.value)
                                    }
                                />
                            </div> */}
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Mobile No</label>
                                <input type="text" className="form-control" placeholder="Enter Mobile No" 
                                    value={mob_no}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setFiltermob(parseInt(onlyNums));
                                    }}
                                />
                            </div> */}
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Area</label>
                                <Select
                                    value={areaOption.find(option => option.value === area) || null}
                                    options={areaOption}
                                    onChange={(selectedOption) => setArea(selectedOption.value)}
                                    placeholder="Select Area"
                                />
                            </div>
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Product</label>
                                <Select
                                    defaultValue={product_pkg_fil_options[0]}
                                    options={product_pkg_fil_options}
                                    placeholder="Select Product"
                                />
                            </div> */}
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Sales Person</label>
                                <Select
                                    defaultValue={sales_person_fil_options[0]}
                                    options={sales_person_fil_options}
                                    placeholder="Select Sales Person"
                                />
                            </div> */}
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Lead Source</label>
                                <Select
                                    options={leadSourceOptions}
                                    value={leadSourceOptions.find(option => option.value === lead_source) || ''}
                                    placeholder="Select Lead Source"
                                    onChange={(selectedOption) => setLeadsource(selectedOption?.value || '')}
                                />
                            </div>
                            {/* <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Lead Type</label>
                                <Select
                                    options={leadtypeopt}
                                    value={leadtypeopt.find(option => option.value === lead_type) || ''}
                                    placeholder="Select Lead Type"
                                    onChange={(selectedOption) => setLeadtype(selectedOption?.value || '')}
                                />
                            </div> */}
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Lead Status</label>
                                <Select
                                    options={leadstatusOptions}
                                    value={leadstatusOptions.find(option => option.value === lead_status) || ''}
                                    placeholder="Select Lead Status"
                                    onChange={(selectedOption) => setLeadstatus(selectedOption?.value || '')}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() => {
                            setLeadId(null);
                            setArea(null);
                            setFilterEmail('');
                            setFiltermob('');
                            setLeadstatus('');
                            setLeadsource('');
                            setLeadtype('');
                            setDateFilSeltValue('all');
                            softRefresh();
                            setvaluefilter('');
                            setPage(1);
                            setPerPage(25);
                            onClose();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )


}
export default Lead;